export default {
	state: {
		parametrosSimuladorBeneficios: {}
	},
	getters: {
		"parametrosSimuladorBeneficios": state => state.parametrosSimuladorBeneficios
	},
	mutations: {
		setParametrosSimuladorBeneficios(state, payload) {
			state.parametrosSimuladorBeneficios = payload
		}
	},
	actions: {
		atualizarEstadoParametrosSimuladorBeneficios({ commit }, payload) {
			commit('setParametrosSimuladorBeneficios', payload)
		}
	}
};